import React from 'react'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import AspectRatio from 'components/utils/AspectRatio'
import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import NestableClickable from 'components/Common/NestableClickable'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Image from 'components/Common/Image/Image'
import PriceRowValueDiscount from 'LuxKit/PricePoints/Value/PriceRowValueDiscount'

const FillHeightGroup = styled(Group)`
  height: 100%;
`

const Root = styled(NestableClickable)`
  width: 75vw;

  ${mediaQueryUp.tablet} {
    width: 40vw;
  }

  ${mediaQueryUp.desktop} {
    width: unset;
  }
`

export type Tag = {
  name: string
  url: string
}

interface Props {
  imageId: string
  title: string
  description: string
  url: string
  savings?: number
}

export function PopularRegionTile(props: Props) {
  const intl = useIntl()

  const viewOffersText = intl.formatMessage({
    id: 'bXMFNkUt/F',
    defaultMessage: 'View offers',
    description: 'Button text to view offers for a popular region',
  })

  return (
    <Root as={ClickableLink} target="_blank" href={props.url}>
      <FillHeightGroup direction="vertical" gap={12} verticalAlign="space-between">
        <VerticalSpacer gap={12}>
          <AspectRatio ratio="16:9">
            <Image alt={props.title} aspectRatio="16:9" id={props.imageId} fit="center" dpr={2} width="375" />
          </AspectRatio>
          <VerticalSpacer gap={4}>
            <BodyText variant="large" lineClamp={2} weight="bold">{props.title}</BodyText>
            {props.savings && <PriceRowValueDiscount
              type="estimate"
              discountPercentage={props.savings}
            />}
          </VerticalSpacer>
          <BodyText variant="medium">{props.description}</BodyText>
        </VerticalSpacer>
        <Group direction="horizontal" horizontalAlign="end">
          <TextButton kind="primary">
            {viewOffersText}
          </TextButton>
        </Group>
      </FillHeightGroup>
    </Root>
  )
}
